export default __webpack_public_path__ + "static/media/frequency.0cc447b7.svg";